import { axios } from "Config/ApiConfig";
import LocalStoragekeys from "Constants/LocalStoragekeys";
import { toast } from "react-toastify";
import ReducerTypes from "Redux/Types/ReducerTypes";

import { persianArabicToEnglish } from "Utils/UnicodeConvert";

import { deleteCookie } from "Redux/Actions";
import { dispatchItemToRedux, setCookie } from ".";
import api from "Constants/Apis";
import API from "Constants/Apis";

const setSignIn = (phoneNumber) => {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      if (
        typeof phoneNumber === "string" &&
        phoneNumber.toString().length < 11
      ) {
        toast("شماره موبایل الزامی است", { type: "error" });
        return reject("mobile needed");
      }
      // dispatch(toggleButtonSpinner(true));
      axios({
        baseURL: API.PUBLIC_API_V2,
        url: `otp/sms/send`,
        method: "POST",
        _addToken: false,
        data: {
          mobile: persianArabicToEnglish(phoneNumber),
        },
      })
        .then((res) => {
          toast(res.data.message, { type: "success" });
          if (res?.data) {
            localStorage.setItem(
              LocalStoragekeys.Show_Referral,
              res?.data?.data?.show_referral
            );
          }
          resolve(true);
        })
        .catch((err) => {
          resolve(false);
        })
        .finally((_) => {
          // dispatch(toggleButtonSpinner(false));
        });
    });
  };
};

const getAccessToken = (params) => {
  // const clientId = uuidv4();
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      const fcmToken = localStorage.getItem(LocalStoragekeys.FCM_Token);
      // dispatch(toggleButtonSpinner(true));
      axios({
        url: "otp/check/login",
        method: "POST",
        _addToken: false,
        data: {
          mobile: persianArabicToEnglish(params.phoneNumber),
          code: persianArabicToEnglish(params.code),
          client_id: persianArabicToEnglish(params.phoneNumber),
          fcm_token: fcmToken,
          user_agent: "web",
        },
      })
        .then((res) => {
          if (res?.data?.data?.access_token) {
            toast("ورود با موفقیت انجام شد", { type: "success" });
            dispatch(
              dispatchItemToRedux({
                type: ReducerTypes.ACCESS_TOKEN,
                payload: res?.data?.data?.access_token,
              })
            );
            setCookie(
              LocalStoragekeys.Access_Token,
              res?.data?.data?.access_token
            );
            saveLocalNameInServer();
            resolve(true);
          }
        })
        .catch((err) => {
          toast(err?.response?.data?.message, { type: "error" });
          reject(err);
        })
        .finally(() => {
          // dispatch(toggleButtonSpinner(false));
        });
    });
  };
};

const signOut = () => {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      axios({
        method: "POST",
        url: "logout",
      })
        .then((res) => {
          if (res) {
           
            deleteCookie(LocalStoragekeys.Access_Token);
          }

          resolve(true);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
       
          toast("خروج با موفقیت انجام شد", { type: "success" });
        });
    });
  };
};

const getProfile = () => {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      axios({
        method: "GET",
        url: "profile",
      })
        .then((res) => {
          dispatch(
            dispatchItemToRedux({
              type: ReducerTypes.PROFILE_DETAIL,
              payload: res.data.data,
            })
          );
          resolve(true);
        
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

const saveLocalNameInServer = () => {
  const user = JSON.parse(localStorage.getItem(LocalStoragekeys.User_Name));
  if (user && user.firstName && user.lastName) {
    let bodyFormData = new FormData();
    bodyFormData.append("name", user.firstName);
    bodyFormData.append("family", user.lastName);
    bodyFormData.append("email", "");
    axios({
      method: "POST",
      url: "profile/edit",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        localStorage.removeItem(LocalStoragekeys.User_Name);
      })
      .catch((err) => {});
  }
};
export {
  setSignIn,
  getAccessToken,
  saveLocalNameInServer,
  getProfile,
  signOut,
};
